// extracted by mini-css-extract-plugin
module.exports = {"menuOptions":"bulkActionDropdown_menuOptions__1MwyS","chevronDownIcon":"bulkActionDropdown_chevronDownIcon__5d1OW","menuItems":"bulkActionDropdown_menuItems__1lFSO"};